(() => {
  const redirects = new Map([
    ['kahlo', '/blogs/picture-trove-blog/copyright-rules#note-on-frida-kahlo'],
    ['vangogh', '/collections/van-gogh-vincent']
  ]);
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || form.getAttribute('role') !== 'search' || event.defaultPrevented) return;
    const query = String(new FormData(form).get('q') || '').trim().toLowerCase();
    const target = redirects.get(query);
    if (target) {
      event.preventDefault();
      window.location.assign(target);
    }
  });
  const container = document.querySelector('[data-pdil-collection-matches]');
  if (!container || !container.dataset.query) return;
  const params = new URLSearchParams({
    q: container.dataset.query,
    'resources[type]': 'collection',
    'resources[limit]': '10',
    section_id: 'pdil-search-collections'
  });
  fetch(`${routes.predictive_search_url}?${params}`)
    .then(response => {if (!response.ok) throw new Error('Search unavailable');return response.text();})
    .then(text => {
      const doc = new DOMParser().parseFromString(text, 'text/html');
      const section = doc.querySelector('#shopify-section-pdil-search-collections');
      if (!section?.querySelector('a')) return;
      container.replaceChildren(...section.childNodes);
      container.hidden = false;
    })
    .catch(() => {});
})();
